<div class="w-full bg-white">

    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-3 px-4 md:px-8 border-b">

        <!-- Title -->
        <div class="w-full flex items-center">
            <arrow-back></arrow-back>
            <div>
                <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">Roles y Permisos</div>
                <div class="ml-0.5 font-medium text-secondary"></div>
            </div>
        </div>

        <!-- Add contact button -->
        <button (click)="agregarRol()"
            *hasPermissions="'administrar_listado_roles_permisos' ; modulos ['Administrar']"
            class="ml-4 min-w-28"
            mat-flat-button
            [color]="'primary'">
            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            <span class="ml-2 mr-1">Nuevo</span>
        </button>
        
    </div>

    <div class="flex flex-col gap-3 px-4 md:px-8 mt-4">
        @for(rol of roles; track rol.tipologiaId){
            <div class="w-full bg-card border-2 border-gray-100 shadow-sm h-16 flex items-center justify-between rounded-md px-8">
                <div  class="flex items-center">
                    <user-avatar-name [name]="rol.descripcion"></user-avatar-name>  
                    <span class="font-bold ml-4">{{rol.descripcion}}</span>
                </div>
                
                <button matButton [matMenuTriggerFor]="menu" class="flex items-center"> 
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    @if(rol.tipologiaId != idRolAdministrador){
                        <button mat-menu-item (click)="actualizarPermisos(rol)">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:pencil'">
                            </mat-icon>
                            Actualizar Permisos
                        </button>
                     }
                    
                    @if(rol.tipologiaId === idRolAdministrador){
                        <button mat-menu-item (click)="actualizarPermisos(rol)">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:eye'">
                            </mat-icon>
                            Ver Permisos
                        </button>
                    }
                    
                    @if(rol.tipologiaId != idRolAdministrador && rol.tipologiaId != idRolTecnico){
                        <button mat-menu-item (click)="eliminarRol(rol)">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:trash'">
                            </mat-icon>
                            Eliminar Rol
                        </button>
                    }
                    
                </mat-menu>
            </div>
        }
    </div>
</div>